const palette = [
    {
        name: "Form background color",
        key: "formBackgroundColor",
        dispatchKey: "SET_DYNAMIC_FORM_BACKGROUND_COLOR",
        hexCode: "#f2f2f2"
    },
    {
        name: "Field background color",
        key: "fieldBackgroundColor",
        dispatchKey: "SET_DYNAMIC_FORM_FIELD_BACKGROUND_COLOR",
        hexCode: "#FFFFFF"
    },
    {
        name: "Field input background color",
        key: "fieldInputBackgroundColor",
        dispatchKey: "SET_DYNAMIC_FORM_FIELD_INPUT_BACKGROUND_COLOR",
        hexCode: "#FFFFFF"
    },
    {
        name: "Field input text color",
        key: "fieldInputTextColor",
        dispatchKey: "SET_DYNAMIC_FORM_FIELD_INPUT_TEXT_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Header text color",
        key: "headerTextColor",
        dispatchKey: "SET_DYNAMIC_FORM_HEADER_TEXT_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Signature color",
        key: "signatureColor",
        dispatchKey: "SET_DYNAMIC_FORM_SIGNATURE_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Scanner QR icon color",
        key: "scannerQRIconColor",
        dispatchKey: "SET_DYNAMIC_FORM_SCANNER_QR_ICON_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Form X icon color",
        key: "formXIconColor",
        dispatchKey: "SET_DYNAMIC_FORM_X_ICON_COLOR",
        hexCode: "#dc3545"
    },
    {
        name: "Section pipe color",
        key: "sectionFieldPipes",
        dispatchKey: "SET_DYNAMIC_FORM_SECTION_FIELD_PIPE_COLOR",
        hexCode: "#00000030"
    },
    {
        name: "Section title color",
        key: "sectionTitleColor",
        dispatchKey: "SET_DYNAMIC_FORM_SECTION_TITLE_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Link color",
        key: "linkColor",
        dispatchKey: "SET_DYNAMIC_FORM_LINK_COLOR",
        hexCode: "#007bff"
    },
    {
        name: "Progress ring path color",
        key: "progressRingPathColor",
        dispatchKey: "SET_DYNAMIC_FORM_PROGRESS_RING_PATH_COLOR",
        hexCode: "#007bff"
    },
    {
        name: "Progress ring trail color",
        key: "progressRingTrailColor",
        dispatchKey: "SET_DYNAMIC_FORM_PROGRESS_RING_TRAIL_COLOR",
        hexCode: "#00000030"
    },
    {
        name: "Progress ring text color",
        key: "progressRingTextColor",
        dispatchKey: "SET_DYNAMIC_FORM_PROGRESS_RING_TEXT_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Missing fields icon color",
        key: "missingFieldsIconColor",
        dispatchKey: "SET_DYNAMIC_FORM_MISSING_FIELDS_ICON_COLOR",
        hexCode: "#dc354590"
    },
    {
        name: "Missing fields popover odd row background color",
        key: "missingFieldsPopoverOddRow",
        dispatchKey: "SET_DYNAMIC_FORM_MISSING_FIELDS_POPOVER_ODD_ROW",
        hexCode: "#f7f7f7"
    }
    ,
    {
        name: "Missing fields popover text color",
        key: "missingFieldsPopoverTextColor",
        dispatchKey: "SET_DYNAMIC_FORM_MISSING_POPOVER_TEXT_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Missing fields popover header color",
        key: "missingFieldsPopoverHeaderColor",
        dispatchKey: "SET_DYNAMIC_FORM_MISSING_POPOVER_HEADER_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Submit button background color",
        key: "submitBtnBackgroundColor",
        dispatchKey: "SET_DYNAMIC_FORM_SUBMIT_BTN_BACKGROUND_COLOR",
        hexCode: "#007bff"
    },
    {
        name: "Submit button text color",
        key: "submitBtnTextColor",
        dispatchKey: "SET_DYNAMIC_FORM_SUBMIT_BTN_TEXT_COLOR",
        hexCode: "#FFFFFF"
    },
    {
        name: "Required field aterisk color",
        key: "requiredFieldAsteriskColor",
        dispatchKey: "SET_DYNAMIC_FORM_REQUIRED_FIELD_ASTERISK_COLOR",
        hexCode: "#dc3545"
    },
    {
        name: "Yes/No selected outline color",
        key: "yesNoSelectedOutlineColor",
        dispatchKey: "SET_DYNAMIC_FORM_YES_NO_SELECTED_OUTLINE_COLOR",
        hexCode: "#007bff"
    },
    {
        name: "Yes/No not selected outline color",
        key: "yesNoNotSelectedOutlineColor",
        dispatchKey: "SET_DYNAMIC_FORM_YES_NO_NOT_SELECTED_OUTLINE_COLOR",
        hexCode: "#00000000"
    },
    {
        name: "Multi select selected background color",
        key: "multiValueLabelBackgroundColor",
        dispatchKey: "SET_DYNAMIC_FORM_MULTI_SELECT_SELECTED_BACKGROUND_COLOR",
        hexCode: "#e6e6e6"
    },
    {
        name: "Multi select selected text color",
        key: "multiValueLabelColor",
        dispatchKey: "SET_DYNAMIC_FORM_MULTI_SELECT_SELECTED_TEXT_COLOR",
        hexCode: "#000000"
    },
    {
        name: "Modal wrapper back button background color",
        key: "modalWrapperbackBtnBackgroundColor",
        dispatchKey: "SET_DYNAMIC_FORM_MODAL_WRAPPER_BACK_BTN_BACKGROUND_COLOR",
        hexCode: "#6c757d"
    },
    {
        name: "Modal wrapper back button text color",
        key: "modalWrapperbackBtnTextColor",
        dispatchKey: "SET_DYNAMIC_FORM_MODAL_WRAPPER_BACK_BTN_TEXT_COLOR",
        hexCode: "#FFFFFF"
    },
    {
        name: "Editor trash bin color",
        key: "editorTrashBinColor",
        dispatchKey: "SET_DYNAMIC_FORM_EDITOR_TRASH_BIN_COLOR",
        hexCode: "#afafaf"
    },
    {
        name: "Editor config gear color",
        key: "editorConfigGearColor",
        dispatchKey: "SET_DYNAMIC_FORM_EDITOR_CONFIG_GEAR_COLOR",
        hexCode: "#afafaf"
    },
    {
        name: "Config disabled",
        key: "configDisabled",
        dispatchKey: "SET_DYNAMIC_FORM_EDITOR_CONFIG_DISABLED_COLOR",
        hexCode: "#ffc107"
    },
    {
        name: "Editor config multi-column warning icon color",
        key: "editorConfigMultiColumnsWarningIconColor",
        dispatchKey: "SET_DYNAMIC_FORM_EDITOR_MULTI_COLUMN_WARNING_ICON_COLOR",
        hexCode: "#ffc107"
    }
]

export default palette